import { EUROPEAN_COUNTRY_CODES } from "./shippingCountries";
import { ShippingLocation } from "../../../common/enums/ShippingLocation";
import type { StoreProduct } from "../../../stores/useReservationStore";
import { getProductTotalQty } from "./productQuantities";

function getShippingLocation(countryCode: string): ShippingLocation {
  if (countryCode === "GR") return ShippingLocation.Greece;
  if (EUROPEAN_COUNTRY_CODES.has(countryCode)) return ShippingLocation.Europe;
  return ShippingLocation.Worldwide;
}

export function calculateShippingFee(
  productsInCart: StoreProduct[],
  countryCode: string,
): number {
  if (!countryCode) return 0;

  const location = getShippingLocation(countryCode);

  const feeData = productsInCart
    .filter((p) => p.canBeShipped && p.shippingInfo)
    .map((p) => {
      const info = p.shippingInfo!.find((si) => si.location === location);
      const qty = getProductTotalQty(p);
      return info && qty > 0
        ? { qty, priceSingleUnit: info.priceSingleUnit, priceAdditionalUnit: info.priceAdditionalUnit }
        : null;
    })
    .filter(Boolean) as { qty: number; priceSingleUnit: number; priceAdditionalUnit: number }[];

  return feeData.reduce(
    (total, p) => total + p.priceSingleUnit + (p.qty - 1) * p.priceAdditionalUnit,
    0,
  );
}